var _rect, _rect2, _circle, _circle2, _rect3, _path, _circle3, _path2, _circle4, _circle5, _circle6, _circle7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTracking(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 12,
    width: 14,
    height: 8,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 17,
    y: 14,
    width: 4,
    height: 6,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 20,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 20,
    r: 2,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 8,
    width: 6,
    height: 6,
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 1.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 6 L6 4 L10 6 L14 4 L18 6 L22 4",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    opacity: 0.7
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 6,
    r: 2,
    fill: "currentColor",
    opacity: 0.8
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 6 L20 8",
    stroke: "currentColor",
    strokeWidth: 1.5,
    fill: "none"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 4,
    r: 1,
    fill: "currentColor",
    opacity: 0.6
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 6,
    r: 1,
    fill: "currentColor",
    opacity: 0.6
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 14,
    cy: 4,
    r: 1,
    fill: "currentColor",
    opacity: 0.6
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 18,
    cy: 6,
    r: 1,
    fill: "currentColor",
    opacity: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTracking);
export default __webpack_public_path__ + "static/media/tracking.f341ef64da1562b66273f10069aa99ec.svg";
export { ForwardRef as ReactComponent };